module.exports = __webpack_public_path__ + "diameter.svg?e9342ee8a831a8ca8e23f44f06c6744f";